export const buildContactList = (email, t) => {
  if (email.list?.name) {
    return `${t('List: ')} ${email.list.name}`
  }
  if (email.team?.name) {
    return `${t('Team: ')} ${email.team.name}`
  }
  return `${t('Event guestlist: ')} ${email.event?.name}`
}
